import React, { useContext, useEffect, useState } from "react";
import "./Login.css";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../utils/context";
import Cookies from "js-cookie";
import { AuthLogin } from "../../features/auth/Slice";
import classNames from "classnames";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [message, setMessage] = useState("");
  const [captcha, setCaptcha] = useState("");
  const { signin, setSignin } = useContext(Context);

  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);

  const generateCaptcha = () => {
    const newCaptcha = Math.floor(
      10000000 + Math.random() * 90000000,
    ).toString(); // 8-digit
    setCaptcha(newCaptcha);
    setValue("number", ""); // clear input field
    clearErrors("number"); // clear validation error
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const onSubmit = async (data) => {
    if (data.number !== captcha) {
      setError("number", {
        type: "manual",
        message: "Captcha does not match",
      });
      return;
    }

    try {
      const result = await dispatch(AuthLogin(data));

      if (result.payload.success) {
        setMessage("Login successful");
        setSuccess(true);

        Cookies.set("fun_ref_admin_security", result.payload.data.token, {
          expires: 365,
        });
        await setSignin(true);
        await navigate("/manage-my-points");
      } else {
        await setMessage(result.payload.message);
        if (result.payload.errors.username?.msg) {
          await setError("username", {
            type: "manual",
            message: result.payload.errors.username?.msg,
          });
        } else {
          await setError("username", {
            type: "manual",
            message: result.payload.errors,
          });
        }
        await setErr("");
      }
    } catch (error) {
      setErr(true);
      console.error(error);
    }
  };

  console.log(errors, "errors");

  return (
    <section className="Login">
      <div className="container">
        <div className="outer_box">
          <div className="box1">
            <p className="location_text">Please allow location service.</p>
            <div className="imgs_div">
              <div className="img_holder">
                <img src="/assets/login/top.jpg" className="img_class1" />
              </div>
              <div className="website_img_holder">
                <img src="/assets/login/top3.jpg  " className="img_class2" />
              </div>
            </div>
          </div>

          <div className="box2">
            <ul>
              <li>
                <a href="#">About Us</a>
              </li>{" "}
              |
              <li>
                <a href="#">MGM</a>
              </li>{" "}
              |
              <li>
                <a href="#">Tutorials</a>
              </li>{" "}
              |
              <li>
                <a href="#">FAQ's</a>
              </li>{" "}
              |
              <li>
                <a href="#">Downloads</a>
              </li>{" "}
              |
              <li>
                <a href="Contact.aspx">Contact Us</a>
              </li>
            </ul>
          </div>

          <div className="box3">
            <div className="login_form_div">
              <Form>
                <div className="inputs_div">
                  <Form.Group className="custom_form_group" controlId="">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter User Name"
                      className={classNames("", {
                        "is-invalid": errors?.username,
                      })}
                      {...register("username", {
                        required: "User Name is required",
                      })}
                      autoComplete="off"
                    />
                  </Form.Group>
                  {errors.username && (
                    <sub className="text-warning">
                      {errors.username.message}
                    </sub>
                  )}
                  {err && <sub className="text-warning">{err}</sub>}

                  <Form.Group className="custom_form_group password_holder">
                    <Form.Label>Password</Form.Label>
                    <div className="password_eye_field">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        {...register("password", {
                          required: "Password is required",
                        })}
                        autoComplete="off"
                      />{" "}
                      <span
                        className="password_eye_icon"
                        onClick={() => setShowPassword((prev) => !prev)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </Form.Group>
                  {errors?.password && (
                    <sub className="text-warning">
                      {errors?.password?.message}
                    </sub>
                  )}

                  <Form.Group className="custom_form_group">
                    <Form.Label>Enter Below Number</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("number", {
                        required: "Captcha is required",
                      })}
                    />
                  </Form.Group>
                  {errors?.number && (
                    <sub className="text-warning">
                      {errors?.number?.message}
                    </sub>
                  )}
                </div>

                <div className="captcha_container">
                  <div
                    className="captcha_holder"
                    onContextMenu={(e) => e.preventDefault()}
                    onCopy={(e) => e.preventDefault()}
                  >
                    {captcha}
                  </div>
                  <div className="refresh_div" onClick={generateCaptcha}>
                    <FontAwesomeIcon
                      icon={faRotateRight}
                      className="refresh_icon"
                    />
                  </div>

                  <button
                    className="go_btn"
                    type="button"
                    onClick={handleSubmit(onSubmit)}
                  >
                    GO
                  </button>
                </div>
              </Form>
            </div>

            <div className="bg_img_div">
              <img src="/assets/login/bottom.jpg" className="bg_img" />
            </div>
          </div>
        </div>

        <p className="footer_text">All Rights Reserved "fun-rep.pro"</p>
      </div>
    </section>
  );
};

export default Login;
